import type { ClientPersonReference } from '@DigitaleDoerfer/digitale-doerfer-api';

export const getPersonName = (person: ClientPersonReference) =>
  `${person.firstName} ${person.lastName}`;
